<template>
  <section class="bg-white sm:pb-12 lg:pb-24">
    <div class="relative max-w-5xl px-4 mx-auto">
      <div class="px-10 py-8 mx-auto bg-black md:px-20 lg:py-16">
        <div class="grid grid-cols-12 gap-y-6">
          <!-- Image Section -->
          <div class="col-span-12 lg:col-span-5">
            <nuxt-img :src="imageSrc" :alt="imageAlt" sizes="xs:160px sm:160px md:160px lg:255px xl:255px 2xl:255px"
              loading="lazy" format="webp" width="255" height="302" class="mx-auto sm-max:w-40 lg:ml-0" />
          </div>

          <!-- Content Section -->
          <div class="col-span-12 lg:col-span-7 lg:px-6">
            <div class="text-xl text-center text-white sm:text-2xl xl:text-28 font-ww-bold" v-html="title"></div>
            <div class="mt-6 text-center text-white sm:text-lg xl:text-xl font-ww-light" v-html="description"></div>

            <div>
              <button @click="scrollTo(buttonLink)"
                class="bg-lifeboost-red text-lg lg:text-xl font-ww-bold text-white w-full uppercase py-2 lg:py-2.5 mt-8 rounded-3xl">
                {{ buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  imageSrc: {
    type: String,
    default: '/assets/images/shield.png',
  },
  imageAlt: {
    type: String,
    default: 'Shield Image',
  },
  title: {
    type: String,
    default: 'Secure Your Anti-Inflation Shield Protection Now',
  },
  description: {
    type: String,
    default: `Lock in your Anti-Inflation Shield protection now and join thousands of smart coffee lovers who are already saving while enjoying the world's cleanest, healthiest coffee.`,
  },
  buttonText: {
    type: String,
    default: 'Subscribe Now',
  },
  buttonLink: {
    type: String,
    default: '#',
  },
});

defineBuilderComponent({
  friendlyName: 'CTAWithBadge',
  inputs: [
    {
      name: 'imageSrc',
      type: 'file',
      friendlyName: 'Image Source',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/shield.png',
    },
    {
      name: 'imageAlt',
      type: 'text',
      friendlyName: 'Image Alt Text',
      defaultValue: 'Shield Image',
    },
    {
      name: 'title',
      type: 'richText',
      friendlyName: 'Section Title',
      defaultValue: 'Secure Your Anti-Inflation Shield Protection Now',
    },
    {
      name: 'description',
      type: 'richText',
      friendlyName: 'Section Description',
      defaultValue:
        `Lock in your Anti-Inflation Shield protection now and join thousands of smart coffee lovers who are already saving while enjoying the world's cleanest, healthiest coffee.`,
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Subscribe Now',
    },
    {
      name: 'buttonLink',
      type: 'url',
      friendlyName: 'Button Link',
      defaultValue: '#',
    },
  ],
});
</script>